module.exports = __webpack_public_path__ + "img/sosial3.54d9da41.svg";